export default __webpack_public_path__ + "static/media/green-card-image.607efba4.svg";